document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.header-wrapper');

  if (!header) return;

  function updateHeaderState() {
    var isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (isMobile) {
      header.classList.remove('header-transparent');
      header.classList.add('header-scrolled');
      return;
    }

    if (window.scrollY > 40) {
      header.classList.remove('header-transparent');
      header.classList.add('header-scrolled');
    } else {
      header.classList.add('header-transparent');
      header.classList.remove('header-scrolled');
    }
  }

  updateHeaderState();
  window.addEventListener('scroll', updateHeaderState, { passive: true });
  window.addEventListener('resize', updateHeaderState);
});